import * as React from "react";
import styled from "styled-components";
import { IE2ETestableComponent } from "../../../../../e2e/IE2ETestableComponent";

export interface ISettingsContent extends IE2ETestableComponent {
  children?: any;
  active?: boolean;
}

export const SettingsPane = ({
  active = false,
  children,
  dataE2EId
}: ISettingsContent) => {
  return (
    <Wrapper active={active} data-e2e-id={dataE2EId}>
      {children}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  position: absolute;
  overflow: auto;
  width: 100%;
  height: 100%;
  display: ${({ active }: { active: boolean }) => (active ? "block" : "none")};
  padding: 2em 0 0 0;

  &:after {
    content: "";
    height: 2em;
    display: block;
  }
`;
